<script lang="ts" setup>
import { useUserStore } from '~/stores/user-store';

const userStore = useUserStore();
</script>

<template>
  <div class="flex items-center gap-4 px-4 py-2">
    <div v-if="userStore.isLoggedIn" class="w-1 min-w-0">
      <slot name="favorite" />
    </div>

    <div class="w-6">
      <slot name="icon" />
    </div>

    <div class="min-w-0 flex-[2]">
      <slot name="title" />
    </div>

    <div class="hidden min-w-0 flex-[5] lg:block">
      <slot name="description" />
    </div>

    <div class="hidden min-w-0 flex-[1] sm:block md:flex-[2]">
      <slot name="tag" />
    </div>

    <div class="hidden w-24 text-right sm:block">
      <slot name="modified" />
    </div>

    <div class="w-5 min-w-0">
      <slot name="menu" />
    </div>
  </div>
</template>
